export const productKeyMap = {
  "zerotrust": 0,
  "microisolate": 1,
  "safebrowser": 2,
  "xdr": 3,

  "ipv6": 4,
  "operatplatform": 5,
  "threatintel": 6,
  "ddi": 7,

  "g5": 8,
  "5g": 8
}
export const solutionList = [
  {
    title: "零信任ZTNA",
    desc: "零信任ZTNA作为新兴网络安全架构,基于永不信任、持续验证的理念,可打造可信身份、可信设备、可信环境、可信网络、可信应用、可信负载以及审计回溯防御体系,架构具备多种应用形态,可适用于移动办公、5G安全、安全上云、应用安全、物联网安全等场景。",
    bgSmall: "/home/solution/back1.png",
    bgLarge: "/home/solution/back1-1.png",
    href: "/product/safe/zerotrust",
    customerList: [
      { title: "中国电信", img: "/home/solution/7.png" },
      { title: "中国移动", img: "/home/solution/10.png" },
      { title: "中国联通", img: "/home/solution/8.png" },
    ]
  },
  {
    title: "自适应微隔离",
    desc: "微隔离技术架构，可以实现在多重网络架构、多种系统形态下，面向业务建立东西向安全管控能力;它可实现通信可视化、最小化安全隔离域，自适应隔离策略，解决架构兼容、跨网络域等管控困难点，将安全管控粒度最小化,并且高效实现安全管控策略下发到业务未端负载中去。",
    bgSmall: "/home/solution/back2.png",
    bgLarge: "/home/solution/back2-1.png",
    href: "/product/safe/microisolate",
    customerList: [
      { title: "中国铁塔", img: "/home/solution/9.png" },
      { title: "中国电信", img: "/home/solution/7.png" },
      { title: "中国联通", img: "/home/solution/8.png" },
    ]
  },
  {
    title: "应用APP安全防护",
    desc: "应用APP安全防护专门解决APP应用程序在使用中的安全接入风险，围绕互联网暴露面、权限管控粗放、业务通信不安全等安全风险实现安全接入防护。",
    bgSmall: "/home/solution/back3.png",
    bgLarge: "/home/solution/back3-1.png",
    href: "",
    customerList: [
      { title: "广东电信", img: "/home/solution/7.png" },
      { title: "立中集团", img: "/home/solution/11.png" },
      { title: "大唐电力", img: "/home/solution/1.png" },
    ]
  },
  {
    title: "企业统一安全浏览器",
    desc: "企业办公过程缺乏企业级统一业务入口，安全风险分散难以控制。企业统一安全浏览器可建立统一办公入口、统一业务发布、统一身份、统一访问、可调度编排安全策略的浏览器访问入口。同时可提供多项安全增值能力协助安全、便捷办公。",
    bgSmall: "/home/solution/back4.png",
    bgLarge: "/home/solution/back4-1.png",
    href: "/product/safe/safebrowser",
    customerList: [
      { title: "中国电信", img: "/home/solution/7.png" },
    ]
  },
  /* {
    title: "IPv6下一代互联网实践",
    desc: "围绕国家IPv6规模化部署，提供IPv6下一代互联网实践，包括应用IPv6双栈转换改造、DNS域名化改造、双栈IP资产全生命周期管理，提供从咨询到改造实施全流程实践协助。",
    bgSmall: "/home/solution/back4.png",
    bgLarge: "/home/solution/back4-1.png",
    href: "/product/network/ipv6",
    customerList: [
      { title: "广东电信", img: "/home/solution/7.png" },
      { title: "杭州教育局", img: "/home/solution/3.png" },
      { title: "湛江政数局", img: "/home/solution/6.png" },
    ]
  }, */
  {
    title: "安全服务",
    desc: "为政府、运营商、企业等客户群体提供安全评估、安全运营、应急响应、渗透测试、安全培训、重要保障等一体化安全服务能力，提升客户安全管理与运营水平",
    bgSmall: "/home/solution/back5.png",
    bgLarge: "/home/solution/back5-1.png",
    href: "/product/network/operatplatform",
    customerList: [
      { title: "广东联通", img: "/home/solution/8.png" },
      { title: "数字广东", img: "/home/solution/4.png" },
      { title: "广东省交通运输厅", img: "/home/solution/2.png" },
    ]
  }
]